// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__bRwtw","shimmer":"Skeleton_shimmer__oa577"};